// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3F-mj","header":"MessagesList_header__3uKc6","chat":"MessagesList_chat__2S5Gt"};